<template>
  <v-container fluid grid-list-xl class="text-xs-center pt-0 pb-0">
    <v-card class="pa-2 card-r shadow-1 grey lighten-4">
      <v-toolbar class="primary card-r pl-2 text-white">
        <v-btn icon class="ma-0 primary text-white card-r no-shadow" to="/examstab#allquestions"> <v-icon>arrow_left</v-icon></v-btn>
        <div class="text-xs-left f-20 ml-3">Edit question</div>
      </v-toolbar>
    <v-layout row wrap class="text-xs-center pl-2 pr-2">

      <v-flex lg12 sm12 xs12 class="pb-0">
        <div class="text-primary f-15 font-weight-bold left">Language type</div>
      </v-flex>
      <v-flex lg3 xs12 class="pa-1 ml-2 ">
        <v-select v-model="selectedLangCategory" solo :items="lang_type" label="Language"></v-select>
      </v-flex>

      <v-flex lg12 sm12 xs12 class="pb-0">
        <div class="text-primary f-15 font-weight-bold left">Question Category</div>
      </v-flex>
      <v-flex lg3 xs12 class="pa-1 ml-2 ">
        <v-select v-model="selectedCategory" solo :items="test_type" label="Question Category"></v-select>
      </v-flex>
      <v-flex lg3 xs12 class="pa-1"  v-show="selectedCategory=='other'">
        <v-text-field v-model="newSelectedCategory" solo label="New Question Category"></v-text-field>
      </v-flex>
      <!-- <v-flex lg3 xs12 class="pa-1 mt-2">
        <v-btn icon large v-show="!seen" v-on:click='seen = !seen' class="ma-0 left card-r grey lighten-3 f-12 card-r"><v-icon>add</v-icon></v-btn>
        <v-btn icon large v-show="seen" class="ma-0 left card-r grey lighten-3 f-12 card-r"><v-icon>add</v-icon></v-btn>
        <v-btn icon large v-show="seen" v-on:click='seen = !seen' class="ma-0 left ml-2 card-r grey lighten-3 f-12 card-r"><v-icon>close</v-icon></v-btn>
      </v-flex> -->
       <v-flex lg12 sm12 xs12 class="pb-0 pt-0">
        <div class="text-primary f-18 font-weight-bold left">Scenario</div>
      </v-flex>
     <v-flex lg12 xs12 class="">
       <v-textarea rows="2" solo class="f-20"
         label="Question" v-model="question.scenario"
       ></v-textarea>
       <!--<v-text-field v-model="question.scenario" solo label="Question"></v-text-field>-->
       <!--<ckeditor :editor="editor" v-model="question.scenario" :config="editorConfig" :upload-adapter="UploadAdapter"></ckeditor>-->
      <!-- <v-flex lg12 sm12 xs12 class="">
          <div class="text-primary f-15 font-weight-bold left">Choose Images</div>
      </v-flex> -->
      </v-flex>
          <v-flex lg12 xs12 class="xs-text-left">
              <input
                type="file"
                style="display:none"
                ref="imageInput"
                :accept="inputAccept"
                @change="onPickedFiles(file_for,$event)"
              >
              <v-btn solo
                    color="primary"
                    class="white--text left ma-0 card-r"
                    @click="onPickFile('image','images')">
                Upload Image
              </v-btn>
          </v-flex>

          <v-flex lg12 sm12 xs12 class="pb-0 pt-3 pb-3" v-if="question.imagePreviews">
            <v-layout>
              <v-flex class="pt-2 pb-2 " xs6 v-for="img in question.imagePreviews" sm4 v-if="question.imagePreviews.length!=0">
                {{img.name}}
                <v-img class="border-r-2"
                       :src=img
                       height="100"
                       width="120"></v-img>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex lg12 sm12 xs12 class="">
            <div class="text-primary f-15 font-weight-bold left">Choose scenario audio {{question.questionList}} dd {{question.answerAudios}}</div>
          </v-flex> -->
          <!--<v-flex lg6 xs12 class="">-->
            <!--<v-text-field v-model="question.scenario" solo label="Upload Audio"></v-text-field>-->
          <!--</v-flex>-->
          <v-flex lg2 d-flex xs12 class="align-center pt-1 text-xs-right right">
            <v-btn solo
                   color="primary"
                   class="white--text left ma-0 card-r"
                   @click="onPickFile('audio','scenario_audio')">Upload Audio
            </v-btn>
          </v-flex>
          <v-flex v-if="question.scenarioAudio.name" style="" lg12 sm12 xs12 class="pb-0 pt-0">
              <div>
              </div>
               <div class="text-primary f-12 pt-1 pb-2 font-weight-bold left text-capitalize">
              <vuetify-audio :file="question.scenarioAudio.name" :ended="audioFinish"></vuetify-audio> </div>
          </v-flex>
      <!-- <v-flex lg12 sm12 xs12 class="pb-0 pt-0">

      <v-flex lg12 sm12 xs12 class="pb-0 pt-0">
        <div class="text-primary f-18 font-weight-bold left">Images</div>
      </v-flex>
      <v-flex lg12 xs12 class="xs-text-left">
        <input
          type="file"
          style="display:none"
          ref="imageInput"
          accept="image/png"
          @change="onPickedImages"
        &gt;
        <v-btn solo
               color="primary"
               class="white&#45;&#45;text left ma-0 card-r"
               @click="onPickImages">
          Change Images
        </v-btn>


      </v-flex> -->
      <!-- <v-flex lg12 sm12 xs12 class="pb-0 pt-3 pb-3">
        <v-layout>
          <v-flex class="pt-2 pb-2 " xs6 sm4 >
            <v-img class="border-r-2"
                   height="100"
                   width="120"></v-img>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex lg12 sm12 xs12 class="pb-0 pt-0">
        <div class="text-primary f-18 font-weight-bold left">Upload Audio</div>
      </v-flex>
      <!--<v-flex lg6 xs12 class="">-->
        <!--<v-text-field v-model="question.scenario" solo label="Upload Audio"></v-text-field>-->
      <!--</v-flex>-->
      <!-- <v-flex lg2 d-flex xs12 class="align-center text-xs-right right">
      <v-flex lg2 d-flex xs12 class="align-center text-xs-right right">
        <v-btn solo
               color="primary"
               class="white--text left ma-0 card-r"
               @click="onPickImages">Upload
        </v-btn>
      </v-flex> -->
      <v-flex lg12 sm12 xs12 class="pb-0">
        <v-tabs v-model="active" class="transparent tab-active pt-2 w-100 mt-4" hide-slider>
        <v-tab ripple class="f-12">Question 1</v-tab>
          <v-tab ripple class="f-12">Question 2</v-tab>
          <v-tab ripple class="f-12">Question 3</v-tab>
          <v-tab ripple class="f-12">Question 4</v-tab>
          <!-- <v-tab ripple class="f-12" v-show="show">Question 4</v-tab> -->
          <!-- <v-div class="">
            <v-btn v-show="!show" v-on:click='show = !show' flat class="ma-0 ml-2 grey lighten-3 f-12 card-r"><v-icon>add</v-icon> Add Question</v-btn>
          </v-div>
          <v-div class="f-12">
            <v-btn icon v-on:click='show = !show' class="ma-0 ml-2 primary f-12 card-r"><v-icon>delete</v-icon></v-btn>
          </v-div> -->
          <v-tab-item v-for="(n,index) in 4" :key="n">
            <v-card flat class="mt-2 transparent ml-2">
              <!-- <v-layout row wrap>-->
                <!--<v-flex lg8 sm12 xs12 class="">-->
                <!--<v-btn icon v-on:click='show = !show' class="ma-0 right ml-2 grey lighten-3 f-12 card-r"><v-icon>delete</v-icon></v-btn>-->
                <!--</v-flex> -->
              <!--</v-layout> -->
                <v-layout row wrap>
                  <v-flex lg12 sm12 xs12 class="pb-0">
                    <div class="text-primary f-12 pt-1 pb-2 font-weight-bold left text-capitalize mt-2">Question</div>

                  </v-flex>
                  <v-flex lg8 xs12 class="pb-0 pt-0">
                    <v-text-field v-model="question.questionList[index]" solo label="Question"></v-text-field>
                    <!--<ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>-->
                  </v-flex>

                </v-layout>

          <v-layout row wrap>
            <v-flex lg12 sm12 xs12 class="pb-0 pt-0">
            <div class="text-primary f-12 pt-1 pb-2 font-weight-bold left text-capitalize">Question Audio</div>
          </v-flex>
          <!--<v-flex lg6 xs12 class="">-->
            <!--<v-text-field v-model="question.scenario" solo label="Upload Audio"></v-text-field>-->
          <!--</v-flex>-->
          <div class="text-primary f-12 pt-1 pb-2 font-weight-bold left text-capitalize ml-2">
          <vuetify-audio v-if="question.questionAudios[index]" :file="question.questionAudios[index]" :ended="audioFinish"></vuetify-audio></div>
          <v-flex lg2 d-flex xs12 class="align-center pt-1 text-xs-right right">
            
            <v-btn solo
                   color="primary"
                   class="white--text left ma-0 card-r"
                   @click="onPickFile('audio','qu_audio',index)">Change Audio
            </v-btn>
          </v-flex>
          <!-- <div>
             {{question.questionAudios[index]}}
             
          </div> -->
          
          <!-- <v-flex v-if="question.questionAudios" v-for="(n, index) in question.questionAudios" style="background-color:#e0e0e0;border:#c1c1c1 solid 1px;" lg12 sm12 xs12 class="pb-0 pt-0"> -->
              <!-- <div>
              </div> -->
            <!-- <div v-if="!quAudChangeState"> -->
              
            <!-- </div> -->
             <!-- </v-flex> -->
             </v-layout>

                  <v-layout row wrap>
                    <v-flex lg12 sm12 xs12 class="pb-0 pt-0">
                      <div class="text-primary f-12 pt-1 pb-2 font-weight-bold left text-capitalize">Answer Explanation</div>
                    </v-flex>
                    <v-flex lg8 xs12 class="pb-0 pt-0">
                      <v-textarea v-model="question.questionDescription[index]" solo rows="3" label="Enter the Answer Explanation"></v-textarea>

                    </v-flex>
                  </v-layout>
                <v-layout row wrap class="">
                  <v-flex lg12 sm12 xs12 class="pb-0 pt-0">
                    <div class="text-primary f-12 pt-1 pb-2 font-weight-bold left text-capitalize">Correct Answer</div>
                  </v-flex>
                  <v-flex lg12 xs12 class="px-0 pt-0 pl-3">
                    <v-radio-group v-model="question.answersList[index]" :mandatory="false" row class="ma-0 pa-0">
                      <v-radio height="30" color="primary" label="Yes" value="yes"></v-radio>
                      <v-radio height="30" color="primary" label="No" value="no"></v-radio>
                    </v-radio-group>
                  </v-flex>
                </v-layout>

             <v-layout row wrap class="">
              <v-flex lg12 sm12 xs12 class="">
            <div class="text-primary f-12 pt-1 pb-2 font-weight-bold left text-capitalize">Explanation audio</div>
          </v-flex>
         
         <div class="text-primary f-12 pt-1 pb-2 font-weight-bold left text-capitalize ml-2">
           <vuetify-audio v-if="question.answerAudios[index]" :file="question.answerAudios[index]" :ended="audioFinish"></vuetify-audio></div>
          <v-flex lg2 d-flex xs12 class="align-center pt-1 text-xs-right right">
          
            <v-btn solo
                   color="primary"
                   class="white--text left ma-0 card-r"
                   @click="onPickFile('audio','ex_audio',index)">Change Audio
            </v-btn>
           <!-- <div>
             {{question.answerAudios[index]}}
           </div> -->
          <!-- <v-flex v-if="question.answerAudios" v-for="(n, index) in question.answerAudios" style="background-color:#e0e0e0;border:#c1c1c1 solid 1px;" lg12 sm12 xs12 class="pb-0 pt-0"> -->
              <!-- <div>
              </div> -->
            </v-flex>
            <!-- </v-flex> -->
             </v-layout>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-flex>
          
         

           
      <v-flex xs12 lg12 class="text-xs-center">
          <v-progress-circular
              indeterminate
              v-if=loading
              color="primary"
          ></v-progress-circular>
          <v-alert
            :value="true"
            color="success"
            icon="check_circle"
            v-if="alert.type=='success'"
            outline
          >
            {{alert.msg}}
          </v-alert>
          <v-alert
            :value="true"
            color="error"
            icon="warning"
            v-if="alert.type=='warning'"
            outline
          >
            {{alert.msg}}
          </v-alert>
      </v-flex>
     <v-flex xs12 class="text-xs-right">
       <v-btn @click="updateQuestion('publish',true)" color="primary no-shadow card-r right" rounded light>Update</v-btn>
        <v-btn @click="updateQuestion('draft',true)" color="grey no-shadow card-r right" rounded>Save as Draft</v-btn>
       <v-btn @click="updateQuestion(question.questionStatus,false,true,'next')" color="butt no-shadow right  card-r" light> <i class="fas fa-forward"></i></v-btn>
       <v-btn @click="updateQuestion(question.questionStatus,false,true,'previous')" color="butt no-shadow right  card-r" light> <i class="fas fa-backward"></i> </v-btn>
      </v-flex>
    </v-layout>
    </v-card>
  </v-container>
</template>
<script>
  /*eslint-disable */

  import api from "@/utils/backend-api"
  import router from '@/router'
  import { mapState } from 'vuex'
  import VuetifyAudio from 'vuetify-audio'
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

  export default {
    props:['id'],
    data: () => ({
      loading:false,
      alert:{
        type:'',
        msg:''
      },
      radios: 'radio-1',
      show: false,
      seen: false,
      test_type: [],
      lang_type:['en','da'],
      active: null,
      dialog: false,
      active1: 'question',
      editor: ClassicEditor,
      editorData: '<p></p>',
      editorConfig: {
      },
      selectedCategory:'',
      selectedLangCategory:'',
      newSelectedCategory:'',
      question:{
        scenario:'',
        scenarioAudio:{name:''},
        questionList:['','','',''],
        questionAudios:[],
        //questionAudiosNames:[],
        questionError:[false,false,false,false],
        questionDescription:['','','',''],
        questionDescError:[false,false,false,false],
        answersList:['','','',''],
        answerAudios:[],
        //answerAudiosNames:[],
        answersListError:[false,false,false,false],
        images:[],
        imagePreviews:[],
        audios:[],
        audiosNames:[],
        questionStatus:''
      },
      errorsIndex:[],
      inputAccept:'',
      file_for:'',
      defaultImageChanged:false,
      defaultScenarioAudioChanged:false,
      // defaultQuAudioChanged:false,
      // defaultExAudioChanged:false,
      quAudChangeState:false,
      exAudChangeState:false,

    }),
      
      
      
     
    created:function(){
      let self=this
      // api.getData('driver/viewQuestionCategory')
      // .then(res=>{
        // Store.dispatch('setQuestionsList', res.data)
        
          let test_type=this.questionsCategories

         
          let newtype=[]
          for(let x=0;x<test_type.length;x++){
            let type={
              text:test_type[x],
              value:test_type[x]
            }
            newtype.push(type)
          }
          let otherType={
            text:'other',
            value:'other'
          }
          newtype.push(otherType)
          this.test_type=newtype

           let lang_type=this.questionsLangCategories
           let langtype=[]
           for(let y=0;y<lang_type.length;y++){
            let ltype={
              text:lang_type[y],
              value:lang_type[y]
            }
            langtype.push(ltype)
          }
          
      // })
      api.postData('driver/viewQuestions/'+this.id,{lang:'en'})
      .then(res=>{
        // Store.dispatch('setQuestionsList', res.data)
          self.setQuestionData(res)
          // }
      })

    },
    methods:{
        setQuestionData(res){
            this.question.questionList=[]
            this.question.questionDescription=[]
            this.question.answersList=[]
            this.question.imagePreviews=[]
            this.question.scenarioAudio=[]
            this.question.questionStatus=''
            this.selectedLangCategory=''
            let question=res.data

            if(res.data.category==null){
              this.selectedCategory='other'
            }else{
              this.selectedCategory=res.data.category
            }
            
            this.question.scenario=res.data.situation
            // // for(let x=1;x<4;x++){
            // this.question.questionList.push(res.data.lang)
            this.question.questionList.push(res.data.q1)
            this.question.questionDescription.push(res.data.q1_explanation)
            this.question.answersList.push(res.data.a1)
            this.question.questionAudios.push(res.data.q1_audio)
            this.question.answerAudios.push(res.data.a1_audio)

            this.question.questionList.push(res.data.q2)
            this.question.questionDescription.push(res.data.q2_explanation)
            this.question.answersList.push(res.data.a2)
            this.question.questionAudios.push(res.data.q2_audio)
            this.question.answerAudios.push(res.data.a2_audio)

            this.question.questionList.push(res.data.q3)
            this.question.questionDescription.push(res.data.q3_explanation)
            this.question.answersList.push(res.data.a3)
            this.question.questionAudios.push(res.data.q3_audio)
            this.question.answerAudios.push(res.data.a3_audio)

            this.question.questionList.push(res.data.q4)
            this.question.questionDescription.push(res.data.q4_explanation)
            this.question.answersList.push(res.data.a4)
            this.question.questionAudios.push(res.data.q4_audio)
            this.question.answerAudios.push(res.data.a4_audio)

            if(res.data.picture){
              this.question.imagePreviews.push(res.data.picture)
            }
            if(res.data.situation_audio){
              this.question.scenarioAudio.name=res.data.situation_audio
            }
            this.question.questionStatus=res.data.status
            this.selectedLangCategory=res.data.lang
            
        },
        loadNextQuestion(type){
          // let a=this.updateQuestion(this.question.questionStatus)
          let self=this
          api.postData('driver/viewNextPreviousQuestion/'+this.id)
          .then(res=>{
            var nullQuestions
            var questionData
            if(type=="next"){
              if(res.data.next_question_data!=null){
                questionData=res.data.next_question_data
              }else{
                nullQuestions=true
              }
            }else if(type=="previous"){
              if(res.data.previous_question_data!=null){
                questionData=res.data.previous_question_data
              }else{
                nullQuestions=true
              }
            }
            if(!nullQuestions){
              this.$router.push('/EditQuestions/'+questionData.id)
              let response={
                data:questionData
              }
              self.setQuestionData(response)
            }

          })
        },
        onPickFile(value,filefor,index=''){
          
          this.file_for=filefor
          this.qu_ans_index=index
          if(value=='image'){
            this.inputAccept="image/png,image/jpg,image/jpeg"
          }else if(value=='audio' || 'qu_audio' || 'ex_audio'){
            this.inputAccept="audio/mp3"
          }
          setTimeout(()=>{
            this.$refs.imageInput.click();
          },2000);
        },
        
         onPickedFiles(file_for,event) {
          
            const files = event.target.files;
            let fileName = files[0].name;

            if(file_for=='images'){
              this.question.images.push(files[0]);

              const fileReader = new FileReader();
              fileReader.readAsDataURL(files[0]);
              fileReader.addEventListener("load", () => {
                this.defaultImageChanged=true
                this.question.imagePreviews=[]
                this.question.imagePreviews.push(fileReader.result);
              });

            }else if(file_for=='scenario_audio'){
              this.defaultScenarioAudioChanged=true
              this.question.scenarioAudio=files[0];
            }else if(file_for=='qu_audio'){
              this.quAudChangeState=true
              this.question.questionAudios[this.qu_ans_index]=files[0];
            // this.question.questionAudiosNames[this.qu_ans_index]=files[0].name;
          }else if(file_for=='ex_audio'){
            this.exAudChangeState=true
            this.question.answerAudios[this.qu_ans_index]=files[0];
            // this.question.answerAudiosNames[this.qu_ans_index]=files[0].name;
          }
            // else if(file_for.startWith('q')){

            //   this.question.audios.push(files[0]);
            //   this.question.audiosNames.push(files[0]);
            // }

            // if (fileName.lastIndexOf(".") <= 0) {
            //   return alert("Please add a valid file! ");
            // }
            // this.quAudChangeState=false
            // this.exAudChangeState=false

        },

        updateQuestion(status,redirect=false,loadNextQuestion=false,questiontype='next'){
          
           if(this.selectedCategory==''){
            this.alert.type="warning"
            this.alert.msg="Please choose category"
            return false
          }
          if(this.question.scenario==''){
            this.alert.type="warning"
            this.alert.msg="Please enter scenario"
            return false
          }
          // let Data={
          //   lang:'en',
          //   category:this.selectedCategory=='other'?this.newSelectedCategory:this.selectedCategory,
          //   situation:this.question.scenario,
          //   status:'publish'
          // }
          this.loading=true
          this.alert.type=""
          let self=this
          try{
            
              let formData=new FormData()
              formData.append('question_id',this.id)
              formData.append('lang',this.selectedLangCategory)
              formData.append('category',this.selectedCategory=='other'?this.newSelectedCategory:this.selectedCategory,)
              formData.append('situation',this.question.scenario)
              formData.append('status',status)
              if(this.defaultScenarioAudioChanged){
                formData.append('situation_audio',this.question.scenarioAudio==null?'':this.question.scenarioAudio)
              }else{
                formData.append('situation_audio','')
              }
              for(let x=0;x<4;x++){
                formData.append('q'+(x+1),this.question.questionList[x]==null?'':this.question.questionList[x])
                formData.append('q'+(x+1)+'_explanation',this.question.questionDescription[x]==null?'':this.question.questionDescription[x])
                // formData.append('q'+(x+1)+'_audio',this.question.audios[x]==null?'':this.question.audios[x])
                formData.append('a'+(x+1),this.question.answersList[x]==null?'':this.question.answersList[x])

                if(this.quAudChangeState){
                formData.append('q'+(x+1)+'_audio',this.question.questionAudios[x]==null?'':((typeof this.question.questionAudios[x])=='object')?this.question.questionAudios[x]:'')
                }else{
                formData.append('q'+(x+1)+'_audio','')
                 }

                if(this.exAudChangeState){
                formData.append('a'+(x+1)+'_audio',this.question.answerAudios[x]==null?'':((typeof this.question.answerAudios[x])=='object')?this.question.answerAudios[x]:'')
                }else{
                formData.append('a'+(x+1)+'_audio','')
                 }
                //formData.append('q'+(x+1)+'_audio',this.question.questionAudios[x]==null?'':this.question.questionAudios[x])
                //formData.append('a'+(x+1)+'_audio',this.question.answerAudios[x]==null?'':this.question.answerAudios[x])
              }
              if(this.defaultImageChanged){
                formData.append('picture',this.question.images[0]==null?'':this.question.images[0])
              }else{
                formData.append('picture','')
              }

              api.postData('driver/updateQuestion',formData)
              .then(res=>{
                if(res.status==201){
                    self.loading=false
                    self.alert.type="success"
                    self.alert.msg="Question updated"
                    if(loadNextQuestion){
                      self.loadNextQuestion(questiontype)
                    }
                }
                if(redirect==true){
                  router.push('/examstab#draft')
                }
                return true

              }).catch(err=>{
                self.loading=false
                self.alert.type="warning"
                self.alert.msg="Question updation failed"
                return false
              })
          }catch(ex){
              this.loading=false
              self.alert.type="warning"
              self.alert.msg="Question updation failed"
              return false
          }
          
        }
    },
    computed: {
      ...mapState({
        questionsList: 'questionsList',
        questionsCategories:'questionsCategories',
        questionsLangCategories:'questionsLangCategories'
    }),
  },

   components: {
        'vuetify-audio': VuetifyAudio
    },
}
</script>



// WEBPACK FOOTER //
// src/pages/pages/exams/EditQuestions.vue